import { AxiosRequestConfig } from 'axios';
import { get } from 'lodash';
import { QueryOptions, useCreateMutation } from '../../CRUD';
import { axiosService } from '../../services';
import { filterKeys } from './keys';
import { UIFiltersStorage } from './types';

const post = async (args?: AxiosRequestConfig['params']) => {
  const { config, body } = args;
  const { data } = await axiosService.request({
    ...config,
    method: 'POST',
    url: '/users/filters',
    data: { ...get(config, 'data', {}), ...body },
  });
  return data;
};

export const useUpdateFilter = (
  options?: QueryOptions<AxiosRequestConfig['params']>,
) =>
  useCreateMutation<UIFiltersStorage>(
    [...filterKeys.many()],
    post,
    '',
    options,
  );
